import { HTTP_TOKEN_REPORT } from "./http";

export const getReportCampaigns = (params) => {
  return HTTP_TOKEN_REPORT.get("report-tracking", { params }).then((result) => {
    return result.data;
  });
};

